import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

import { API_ROOT } from 'utils';
import { RootState } from 'store/configureStore';
import type { Lead } from '@backend/src/interfaces/mongoose.gen';
import type { PartialDeep } from 'type-fest';

const backendApi = createApi({
  reducerPath: 'backendApi',
  baseQuery: retry(
    fetchBaseQuery({
      baseUrl: API_ROOT,
      // Default timeout of 30 seconds
      timeout: 30000,
      prepareHeaders: (headers, { getState }) => {
        const state = getState() as RootState;
        const token = state.app.token as string;

        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }

        return headers;
      },
    }),
  ),
  endpoints: (builder) => ({
    updateLead: builder.mutation<
      Lead,
      {
        lead: Omit<PartialDeep<Lead>, 'id'> & { id: Lead['_id'] };
        connectionId: string;
      }
    >({
      query: ({ lead, connectionId }) => ({
        url: `lead/${lead.id}`,
        method: 'POST',
        // fetchBaseQuery automatically adds `content-type: application/json` to
        // the Headers and calls `JSON.stringify(patch)`
        body: { lead, connectionId },
      }),
    }),
    createLead: builder.mutation<Lead, PartialDeep<Lead>>({
      query: (lead) => ({
        url: `lead`,
        method: 'POST',
        // fetchBaseQuery automatically adds `content-type: application/json` to
        // the Headers and calls `JSON.stringify(patch)`
        body: lead,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
// export const { updateLead } = backendApi;

export default backendApi;
